module.exports = __webpack_public_path__ + "static/media/business_40.7aa7904a.svg";